<script>
// import axios from "axios";

import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import axios from "axios";
import moment from "moment";
// eslint-disable-next-line no-unused-vars
import NumerosaLetras from "../../../../helpers/numeros";
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import { authComputed } from "@/state/helpers";

/**
 * Products component
 */
// eslint-disable-next-line no-unused-vars
export default {
  page: {
    title: "Product",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      apiUrl: process.env.VUE_APP_URL,
      logoUrl: (process.env.BASE_URL || "/") + "logo.jpeg",
      userT: this.$store.state.authfack.user,
      httpOptions: {
        headers: { "x-token": this.$store.state.authfack.user.token },
      },
      formPro: {
        direccionp: "",
        empleado: "",
        nit_cliente: "",
        no_orden: "",
        observaciones: "",
        fecha_compra: "",
        tienda: "",
        cliente: "",
        dias_vencimiento: "",
        totalPendiente: 0,
        totalPagado: 0,
        vendedor: "",
        total: "",
        state: true,
        id: 0,
      },
      estadoCredito: false,
      formFactura: {
        fecha_emision: "",
        fecha_certificacion: "",
        dataCert: "",
        serie: "",
        number: "",
        uuid: "",
      },
      detalleorden: [],
      title: "IMPRIMIR",
      items: [
        {
          text: "Cotización",
          href: "/",
        },
        {
          text: "Imprimir cotización",
          active: true,
        },
      ],
      detalleProducto : [],
      detalleServicio :[],
        arqueo :{},
        creditos : [],
        creditosTaller:[],
        adelantoTaller: [],
    };
  },
  mounted() {
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: { "x-token": usuario.token },
      })
        .then((res) => {
          if (res.data.success) {
            // this.$router.push("/");
          }
        })
        .catch(() => {
          this.logout();
          location.reload();
        });
    }
    this.detalle();
  },
  updated() {
    this.$refs["buttonImprimir"].click();
  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    letras(cantidad) {
      let a;
      a = NumerosaLetras(cantidad);
      return a;
    },
    formatQuetzales (amount) {
        let num = parseFloat(amount), formatted
        formatted =  num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
        return amount = 'Q ' + formatted
    },
    // FUNCIONES AUXILIARES
    money(value) {
      return (
        "Q " +
        parseFloat(value)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
  getDiferenciaCaja(arqueo) {
    const registrado = parseFloat(arqueo.fin_caja) + parseFloat(arqueo.monto_deposito || 0);
    const deberiaHaber =
      parseFloat(arqueo.inicio_caja) +
      parseFloat(arqueo.fin_adelantos) +
      parseFloat(arqueo.fin_sistema) +
      parseFloat(arqueo.fin_abonos) +
      parseFloat(arqueo.fin_abonos_taller || 0) -
      parseFloat(arqueo.fin_egresos);

    return registrado - deberiaHaber;
  },
  getResultadoCaja(arqueo) {
    const diferencia = this.getDiferenciaCaja(arqueo);
    if (Math.abs(diferencia) < 0.01) {
      return 'Caja completa';
    } else if (diferencia > 0) {
      return 'Dinero que sobra';
    } else {
      return 'Dinero extraviado';
    }
  },
    quantity(value) {
      return parseFloat(value)
        .toFixed(2)
        .replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
    },
    showDate(date) {
      return moment(date).locale("es").utc().format("MMMM DD [de] YYYY");
    },
    showHour(date) {
      return moment(date).locale("es").format("MMM Do YYYY HH:mm");
    },
    detalle() {
    //   let me = this;
      axios
        .get(
          process.env.VUE_APP_URL +
            "caja/recibo?id=" +
            this.$route.params.id,
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then((response) => {
        console.log(response)
            this.arqueo = response.data.arqueo;
            this.creditos = response.data.creditos;
            this.creditosTaller = response.data.creditosTaller;
            this.adelantoTaller = response.data.AdelantosTaller;


        });
    },
    calcularTotal() {
      let total = 0;
      this.detalleServicio.forEach(item => {
        total += item.subtotal_servicio;
      });
      return this.money(total);
    },
    calcularTotalRepuestos() {
      let total = 0;
      this.detalleProducto.forEach(item => {
        total += item.subtotal_venta;
      });
      return this.money(total);
    },
    formatoPresentacion(date){
        return moment(date).locale('es').format('LL');
    },
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" class="d-print-none" />

    <!-- Botones -->
    <div class="row mt-4 d-print-none">
      <div class="col">
        <router-link
          :to="{ name: 'inicioCaja' }"
          class="btn text-muted d-none d-sm-inline-block btn-link"
        >
          <i class="mdi mdi-arrow-left me-1"></i>REGRESAR
        </router-link>
      </div>
      <div class="col">
        <div class="float-end">
          <a
            ref="buttonImprimir"
            href="javascript:window.print()"
            class="btn btn-primary w-md waves-effect waves-light me-1"
          ><i class="fa fa-print"></i>&nbsp;&nbsp;IMPRIMIR</a>
        </div>
      </div>
    </div>

    <!-- Arqueo -->
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body cz">
            <!-- Header corporativo -->
            <div class="cz-header">
              <div class="cz-brand">
                <img :src="logoUrl" alt="Logo" class="cz-logo" />
                <div>
                  <div class="cz-name">Taller de Reparación Ariel</div>
                  <div class="cz-contact"><i class="bx bx-phone"></i> 4889 9653 · 4477 4533</div>
                  <div class="cz-contact"><i class="bx bx-map"></i> Comapa, Jutiapa</div>
                </div>
              </div>
              <div class="cz-doc">
                <div class="cz-doc-title">ARQUEO DE CAJA</div>
                <div class="cz-doc-user">{{ arqueo.user.usuario }}</div>
                <div class="cz-doc-date">{{ this.formatoPresentacion(arqueo.fecha_registrada) }}</div>
              </div>
            </div>

            <div class="cz-obs" v-if="arqueo.observacion">
              <span>Observaciones:</span> {{ arqueo.observacion }}
            </div>

            <!-- Resumen Ejecutivo -->
            <div class="cz-section">Resumen ejecutivo</div>
            <table class="cz-table">
              <tbody>
                <tr><td>Monto inicial caja</td><td class="r">{{ formatQuetzales(arqueo.inicio_caja) }}</td></tr>
                <tr><td>Ventas del día (sin créditos)</td><td class="r">{{ formatQuetzales(arqueo.fin_sistema) }}</td></tr>
                <tr><td>Créditos abonados</td><td class="r">{{ formatQuetzales(arqueo.fin_abonos) }}</td></tr>
                <tr><td>Abonos taller</td><td class="r">{{ formatQuetzales(arqueo.fin_abonos_taller || 0) }}</td></tr>
                <tr><td>Adelantos</td><td class="r">{{ formatQuetzales(arqueo.fin_adelantos) }}</td></tr>
                <tr class="cz-pos">
                  <td><strong>TOTAL DINERO</strong></td>
                  <td class="r"><strong>{{formatQuetzales(
                    parseFloat(arqueo.inicio_caja) +
                    parseFloat(arqueo.fin_sistema) +
                    parseFloat(arqueo.fin_abonos) +
                    parseFloat(arqueo.fin_adelantos) +
                    parseFloat(arqueo.fin_abonos_taller || 0))}}</strong></td>
                </tr>
                <tr><td>Total egresos</td><td class="r">{{ formatQuetzales(arqueo.fin_egresos) }}</td></tr>
                <tr class="cz-info">
                  <td><strong>TOTAL DINERO MENOS EGRESOS</strong></td>
                  <td class="r"><strong>{{formatQuetzales(
                    parseFloat(arqueo.inicio_caja) +
                    parseFloat(arqueo.fin_sistema) +
                    parseFloat(arqueo.fin_abonos) +
                    parseFloat(arqueo.fin_adelantos) +
                    parseFloat(arqueo.fin_abonos_taller || 0) -
                    parseFloat(arqueo.fin_egresos))}}</strong></td>
                </tr>
              </tbody>
            </table>

            <!-- Resumen de cajas -->
            <div class="cz-section">Resumen de cajas</div>
            <table class="cz-table">
              <tbody>
                <tr><td>Registrado en efectivo</td><td class="r">{{ formatQuetzales(arqueo.fin_caja) }}</td></tr>
                <tr><td>Registrado en depósitos</td><td class="r">{{ formatQuetzales(arqueo.monto_deposito || 0) }}</td></tr>
                <tr><td>Fin total empleado</td>
                  <td class="r">{{ formatQuetzales(parseFloat(arqueo.fin_caja) + parseFloat(arqueo.monto_deposito || 0)) }}</td></tr>
                <tr><td>Total que debería haber</td>
                  <td class="r">{{ formatQuetzales(
                    parseFloat(arqueo.inicio_caja) +
                    parseFloat(arqueo.fin_adelantos) +
                    parseFloat(arqueo.fin_sistema) +
                    parseFloat(arqueo.fin_abonos) +
                    parseFloat(arqueo.fin_abonos_taller || 0) -
                    parseFloat(arqueo.fin_egresos)) }}</td></tr>
                <tr class="cz-result">
                  <td><strong>{{ getResultadoCaja(arqueo) }}</strong></td>
                  <td class="r"><strong>{{ formatQuetzales(getDiferenciaCaja(arqueo)) }}</strong></td>
                </tr>
              </tbody>
            </table>

            <!-- Depósitos -->
            <div class="cz-section">Resumen de depósitos</div>
            <table class="cz-table">
              <thead>
                <tr><th>Descripción</th><th class="r">Monto</th></tr>
              </thead>
              <tbody>
                <tr>
                  <td>No. Depósito {{ arqueo.no_deposito }}</td>
                  <td class="r">{{ formatQuetzales(arqueo.monto_deposito == null ? 0 : arqueo.monto_deposito) }}</td>
                </tr>
              </tbody>
            </table>

            <!-- Egresos -->
            <div class="cz-section">Resumen de egresos</div>
            <table class="cz-table">
              <thead>
                <tr><th>Razón</th><th>Usuario</th><th class="r">Monto</th></tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in arqueo.egresos" v-bind:key="index">
                  <td>{{ item.razon }}</td>
                  <td>{{ item.user.usuario }}</td>
                  <td class="r">{{ formatQuetzales(item.monto) }}</td>
                </tr>
              </tbody>
            </table>

            <!-- Abono créditos -->
            <div class="cz-section">Resumen de abono · créditos de venta</div>
            <table class="cz-table">
              <thead>
                <tr>
                  <th>No. venta</th><th>Cliente</th><th>Fecha pago</th>
                  <th>Modo pago</th><th class="r">Cantidad abonada</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in creditos" v-bind:key="index">
                  <td>{{ item.venta.no_ducumento_v }}</td>
                  <td>{{ item.venta.cliente.persona.nombre_persona + ' ' + item.venta.cliente.persona.apellido_persona }}</td>
                  <td>{{ item.fecha_pago }}</td>
                  <td>{{ item.metodo_pago }}</td>
                  <td class="r">{{ formatQuetzales(item.abono) }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr><td colspan="4" class="r">TOTAL</td><td class="r">{{ formatQuetzales(arqueo.fin_abonos) }}</td></tr>
              </tfoot>
            </table>

            <!-- Abono créditos taller -->
            <div class="cz-section">Resumen de abono · créditos de taller</div>
            <table class="cz-table">
              <thead>
                <tr>
                  <th>No. servicio</th><th>Cliente</th><th>Fecha pago</th>
                  <th>Modo pago</th><th class="r">Cantidad abonada</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in creditosTaller" v-bind:key="index">
                  <td>{{ item.taller.no_servicio }}</td>
                  <td>{{ item.taller.vehiculo.cliente.persona.nombre_persona }}</td>
                  <td>{{ item.fecha_pago }}</td>
                  <td>{{ item.metodo_pago }}</td>
                  <td class="r">{{ formatQuetzales(item.abono) }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr><td colspan="4" class="r">TOTAL</td><td class="r">{{ formatQuetzales(arqueo.fin_abonos_taller) }}</td></tr>
              </tfoot>
            </table>

            <!-- Adelantos taller -->
            <div class="cz-section">Resumen de adelantos de taller</div>
            <table class="cz-table">
              <thead>
                <tr><th>No. servicio</th><th>Cliente</th><th class="r">Total</th></tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in adelantoTaller" v-bind:key="index">
                  <td>{{ item.taller.no_servicio }}</td>
                  <td>{{ item.taller.vehiculo.cliente.persona.nombre_persona + '::' + item.taller.vehiculo.modelo.auto.nombre_auto+ ' '
                     + item.taller.vehiculo.modelo.nombre_modelo + ' ' + item.taller.vehiculo.anio+ '::' + item.taller.vehiculo.placa }}</td>
                  <td class="r">{{ formatQuetzales(item.adelanto) }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr><td colspan="2" class="r">TOTAL</td><td class="r">{{ formatQuetzales(arqueo.fin_adelantos) }}</td></tr>
              </tfoot>
            </table>

            <div class="cz-footer">Taller de Reparación Ariel · Arqueo de caja</div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.cz { color: #2b2f3a; font-size: 13px; }

.cz-header {
  display: flex; align-items: center; justify-content: space-between;
  border-bottom: 4px solid #1b2a4e; padding-bottom: 16px; margin-bottom: 14px;
}
.cz-brand { display: flex; align-items: center; gap: 16px; }
.cz-logo { height: 78px; width: auto; object-fit: contain; border-radius: 8px; }
.cz-name { font-size: 23px; font-weight: 800; color: #1b2a4e; }
.cz-contact { font-size: 12px; color: #6b7280; margin-top: 2px; }
.cz-doc { text-align: right; }
.cz-doc-title {
  background: #1b2a4e; color: #fff; font-weight: 700; font-size: 13px;
  padding: 6px 14px; border-radius: 4px; letter-spacing: 1px; display: inline-block;
}
.cz-doc-user { font-size: 17px; font-weight: 800; color: #c5a253; margin-top: 6px; }
.cz-doc-date { font-size: 12px; color: #6b7280; }

.cz-obs {
  background: #f7f9fc; border-left: 3px solid #c5a253; border-radius: 4px;
  padding: 8px 12px; font-size: 12px; color: #4b5563; margin-bottom: 6px;
}
.cz-obs span { color: #8a909c; text-transform: uppercase; font-size: 10px; letter-spacing: .5px; }

.cz-section {
  font-size: 13px; font-weight: 700; color: #1b2a4e;
  margin: 18px 0 8px; padding-left: 10px; border-left: 4px solid #c5a253;
}

.cz-table { width: 100%; border-collapse: collapse; margin-bottom: 6px; }
.cz-table thead th {
  background: #1b2a4e; color: #fff; font-size: 10px; font-weight: 600;
  text-transform: uppercase; padding: 8px; text-align: left;
}
.cz-table tbody td { padding: 7px 8px; border-bottom: 1px solid #eef0f4; font-size: 12px; }
.cz-table tbody tr:nth-child(even) { background: #f9fafc; }
.cz-table tfoot td {
  padding: 8px; font-weight: 700; color: #1b2a4e; background: #eef1f7; font-size: 13px;
}
.cz-table .r { text-align: right; }
.cz-pos { background: #eafaf2 !important; }
.cz-pos td { color: #1f8a5b; }
.cz-info { background: #eaf1fb !important; }
.cz-info td { color: #1b2a4e; }
.cz-result { background: #fff6f4 !important; }
.cz-result td { color: #1b2a4e; }

.cz-footer {
  margin-top: 26px; text-align: center; color: #8a909c; font-size: 11px;
  border-top: 1px solid #e7e9ef; padding-top: 10px;
}

@media print {
  .cz, .cz * { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
}
</style>
